<!-- 
Panel for displaying a preview of a notice template.
-->
<template>
  <div>
    <div v-if="state.loaded">
      <div class="subheading font-weight-medium pb-3">{{ subject }}</div>
      <!-- eslint-disable-next-line vue/no-v-text-v-html-on-component vue/no-v-html -->
      <div class="pt-3 pl-3 pb-3 pr-3 email-content" v-html="body"/>
    </div>
    <our-loading-indicator v-else/>
  </div>
</template>

<script>
import * as action from "@/store/notice-templates/action-types";

export default {
  props: {
    levyCollectionId: {
      required: true,
      type: Number
    },
    noticeType: {
      required: true,
      type: String
    }
  },
  data() {
    return {};
  },
  computed: {
    state() {
      return this.$store.state.noticeTemplates.preview;
    },
    loaded() {
      return this.state.loaded;
    },
    levyCollectionTemplate() {
      return this.state.data;
    },
    subject() {
      return this.levyCollectionTemplate.subject;
    },
    body() {
      return this.levyCollectionTemplate.body;
    }
  },
  watch: {
    levyCollectionId() {
      this.reload();
    },
    noticeType() {
      this.reload();
    },
    loaded() {
      this.reload();
    }
  },
  mounted() {
    this.reload();
  },
  methods: {
    async reload() {
      const needsRefreshed =
        (!this.state.loaded && !this.state.loading) ||
        this.state.levyCollectionId != this.levyCollectionId ||
        this.state.noticeType != this.noticeType;
      if (needsRefreshed) {
        await this.$store.dispatch(action.PREVIEW_GET, {
          levyCollectionId: this.levyCollectionId,
          noticeType: this.noticeType
        });
      }
    }
  }
};
</script>
